  
<template>
  <header>
    <div class="hpHeader row">
       <div class="content col-sm-12">
             <router-link to="/" id="goHomeButton" class="logo">
                <img class="logoImage" src="../assets/branding/hp-logo-256.png" alt="HP"/>
                <div class="logoName">{{title}}</div>
             </router-link>
       </div>
    </div>
  </header>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>

.hpHeader {
  width: 100%;
  height: 50px;
  margin: 0px 0px 15px 0px;
  padding: 11px 0;
  padding-top: 11px;
}
.content {
  height: 48px;
   display: flex;
   justify-content: space-between;
   color: $hpBlack;
   font-size: 28px;
}


.logo {
   position: relative;
   display: inline-flex;
   padding-right: 37px;
   cursor: pointer;
   text-decoration: none;
   color: inherit;
 }
 .logoImage {
   width: 50px;
   height: 50px;
   margin-right: 15px;
 }
 .logoName {
   margin: auto;
  margin-left: 10px;
   color: $hpBlack;
   font-size: 25px;
   font-weight: $hpFontWeightMedium;
 }

img {
  width: 50px;
  height: 50px;
}
</style>